import { render, staticRenderFns } from "./targetGroupPopover.vue?vue&type=template&id=1284b8dd&"
import script from "./targetGroupPopover.vue?vue&type=script&lang=js&"
export * from "./targetGroupPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports